import classnames from "classnames";
import { capitalize } from "neetocist";
import { globalProps } from "neetocommons/initializers";
import withT from "neetocommons/react-utils/withT";
import { RightArrow } from "neetoicons";
import { Button, Typography } from "neetoui";

const WelcomeScreen = withT(({ t, setCurrentStep, nextStep, className }) => (
  <div
    className={classnames("neeto-molecules-onboarding__wrapper", className)}
    data-testid="onboarding-welcome-wrapper"
  >
    <div className="mx-auto mb-6 flex w-full max-w-2xl flex-col gap-y-2 px-6 pt-16">
      <Typography
        className="text-center"
        data-testid="onboarding-welcome-title"
        style="h1"
      >
        {t("neetoMolecules.onboarding.helpScreen.welcomeToTitle", {
          appName: capitalize(globalProps.appName),
        })}
      </Typography>
      <Typography
        className="text-center"
        data-testid="onboarding-welcome-description"
        lineHeight="normal"
        style="body1"
      >
        {t("neetoMolecules.onboarding.letUsCustomize", {
          appName: capitalize(globalProps.appName),
        })}
      </Typography>
    </div>
    <Button
      data-testid="onboarding-welcome-button"
      icon={() => <RightArrow className="rtl:scale-x-[-1]" size={16} />}
      label={t("neetoMolecules.onboarding.getStarted")}
      onClick={() => setCurrentStep(nextStep)}
    />
  </div>
));

export default WelcomeScreen;
